import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "error", "label", "margin"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { Block, ValidationSummary } from '../content';
const StripeCardWrapper = _ref => {
  let {
      children,
      error,
      label,
      margin = 4
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Block, _extends({}, rest, {
    className: "MuiFormControl-root MuiTextField-root  MuiFormControl-marginNormal",
    margin: margin
  }), /*#__PURE__*/React.createElement("label", {
    className: "MuiFormLabel-root MuiFormLabel-colorSecondary MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
  }, label), /*#__PURE__*/React.createElement("label", {
    className: "MuiInput-underline",
    style: {
      width: '100%',
      marginTop: 16,
      paddingTop: 6,
      paddingBottom: 7
    }
  }, children)), /*#__PURE__*/React.createElement(ValidationSummary, {
    errorMessage: error,
    marginTop: 0
  }));
};
export default StripeCardWrapper;